import React from "react";
import ReactDOM from 'react-dom';
import './tabela.css';
import NumberFormat from 'react-number-format';



export default class Zestawieniahtml2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = { 
        data3: props.data, 
        dzis: new Date().toLocaleString(),
        stalytekst: props.stalytekst,
        uchwala: props.uchwala,
        }
    }

render() {
const { data3, dzis } = this.state;
const poprzedni = this.props.rok - 1;
let stopka = data3.stopka;
let wyddoch = this.props.grupaZestawienValuetext.charAt(0);


return (
<React.Fragment>
<div className="m-1">
<div className='row mb-2'>
  <div className="col text-right"><span className="text-right">{this.state.stalytekst}</span></div>
</div>
<table class="printable" cellSpacing="0" border="0">
<colgroup width="67"></colgroup>
<colgroup width="90"></colgroup>
<colgroup span="4" width="67"></colgroup>
<colgroup width="100"></colgroup> {/* @*nazwa*@ */}
<colgroup width="136"></colgroup> {/* @*obowiazujacyplan*@ */}
<colgroup width="110"></colgroup> {/* @*zwiekszenia*@ */}
<colgroup width="110"></colgroup> {/* @*zmniejszenia*@ */}
<colgroup width="150"></colgroup> {/* @*plan po*@ */}
<tbody>
    <tr>
        <td className="td-1" colSpan="2" height="47" align="center" valign="top"><i>Sygnatura</i></td>
        <td className="td-1" colSpan="9" align="center" valign="middle"><b><font size="3" color="#000080">Porównanie z rokiem ubiegłym dla uchwały {this.state.uchwala} <br /> na  dzień {dzis} </font></b></td>
        <td className="td-1" colSpan="2" align="center"></td>
    </tr>
    <tr>
        <td className="td-2" height="21" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="right"><b>Adresat:</b></td>
        <td className="td-3" colSpan="2" align="center"><b><font size="3">{data3.adresat}</font></b></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        {/* @*<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
        <td className="td-1" >Część budżetu: </td>
        <td className="td-4" colSpan="6" align="center">{data3.czescBudzetu}</td>
        <td align="left"></td>
        {/* @*<td align="left"></td>*@ */}
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" colSpan="2" height="18" align="center" valign="bottom"></td>
        <td align="left"></td>
        {/* @*<td style=" border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
        <td className="td-5">{wyddoch === "D" ? (<p>Dochody na zadania:</p>) : (<p>Wydatki na zadania:</p>)}</td>
        <td className="td-6" colSpan="6" align="center">{data3.rodzaje}</td>
        <td align="left"></td>
        {/* @*<td align="left"></td>*@ */}
        <td align="left"></td>
        <td className="td-3" align="center"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        {/* @*<td style="border-top: 1px solid #000000; border-bottom: 1px solid #000000; border-left: 1px solid #000000" align="left"></td>*@ */}
        <td className="td-1">Wydziały: </td>
        <td className="td-4" colSpan="6" align="center">{data3.wydzialy}</td>
        <td align="left"></td>
        {/* @*<td align="left"></td>*@ */}
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" colSpan="4" height="18" align="left" valign="bottom"><i>pieczątka wydziału</i></td>
        <td align="left"><i></i></td>
        <td align="center"><i></i></td>
        <td align="left"><i></i></td>
        <td align="left"><i></i></td>
        <td align="left"><i></i></td>
        <td class="tabela" width="15%" align="center"><b><i>Plan na początek {poprzedni}</i></b></td>
        <td class="tabela" width="15%" align="center"><b><i>Przewidywane wykonanie za wrzesień {poprzedni} </i></b></td>
        <td class="tabela" width="15%" align="center"><b><i>Plan aktualny</i></b></td>
        <td class="tabela" width="5%" align="center"><b><i>Plan aktualny do przewidywanego (%)</i></b></td>
    </tr>
    <tr>
        <td class="tabela" colSpan="9" height="21" align="center"><b><font size="3">{data3.czescBudzetu} </font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.sumCol0} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.sumCol1} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.sumCol2} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
        <td class="tabela" align="right"><b><font size="2"><NumberFormat value={data3.procent} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></font></b></td>
    </tr>
    {data3.dane ? (data3.dane.map(dane1 => {
    const { nazwaGrupy, sumCol0, sumCol1, sumCol2, procent, dane} = dane1;
    return (<>
    <tr key="a">
        <td class="tabela" colSpan="9"><b><font size="3">{nazwaGrupy} </font></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={sumCol0} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={sumCol1} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={sumCol2} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
        <td class="tabela" align="right"><b><NumberFormat value={procent} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></b></td>
    </tr>
    {dane.map(dane3 => {
        const { dzial, rozdzial, paragraf, p4, pozycja, nazwa, poczatekRokPoprzedni, wykonanieRokPoprzedni, planRokBiezacy, procentWykonaniaDoPlanu} = dane3;
        return (<>
        <tr>
            <td class="tabela" height="8" align="center"> {dzial}</td>
            <td class="tabela" height="9" align="center">{rozdzial}</td>
            <td class="tabela" height="8" align="center">{paragraf}{p4}</td>
            <td class="tabela" height="9" align="center">{pozycja}</td>
            <td class="tabela" colspan="5" align="left" valign="middle">{nazwa}</td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={poczatekRokPoprzedni} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={wykonanieRokPoprzedni} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={planRokBiezacy} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
            <td class="tabela" align="right" valign="middle"><NumberFormat value={procentWykonaniaDoPlanu} thousandSeparator={' '} displayType={'text'} fixedDecimalScale={true} decimalScale={2} decimalSeparator={','} /></td>
        </tr>
        </>); }
    )}

    </>);}
    ) ): null} 

   
         
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr></tr>
    <tr>
    <td colSpan="13"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left">Opis:</td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    {data3.uwagi2 ? (<>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td colSpan="11"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td colSpan="11"><div dangerouslySetInnerHTML={ { __html: data3.uwagi2 } }></div></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td colSpan="11"></td>
        <td className="td-3" align="left"></td>
    </tr>

    </>) : null}
    
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td align="left"></td>
        <td className="td-3" align="left"></td>
    </tr>
    <tr>
        <td className="td-2" height="17" align="center"></td>
        <td align="left" colSpan="3"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</font></td>
        <td align="left"></td>
        <td align="center" colSpan="2"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
        <td align="left"></td>
        <td align="center" colSpan="3"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;</font></td>
        <td className="td-3" colSpan="2" align="center"><font face="Verdana">&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;&hellip;..</font></td>
    </tr>
    <tr>
        <td className="td-2"></td>
        <td  colSpan="3" height="17" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaLewo } }></div></td>
        <td align="left" ><font face="Verdana" size="1"><br></br></font></td>
        <td align="left" colSpan="2"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaData } }></div></td>
        <td align="center" ><i><font face="Verdana" size="1"><br></br></font></i></td>
        <td align="center" colSpan="3"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaSrodek } }></div></td>
        <td className="td-3" colSpan="2" align="center"><div dangerouslySetInnerHTML={ { __html: stopka.stopkaPrawo } }></div></td>
    </tr>
    <tr>
        <td className="td-8" height="17" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-7" align="left"></td>
        <td className="td-6" align="left"></td>
    </tr>
</tbody>
</table>

</div>

</React.Fragment>
);
}
}
